module.exports = __webpack_public_path__ + "img/87.da21ab1c.jpg";